module.exports = __webpack_public_path__ + "assets/img/45@3x.9c302374.png";